import React, { useContext, useEffect } from "react";
import { StepContext } from "../../context/StepContext";
import { AnswersContext } from "../../context/AnswersContext";
import { UserContext } from "../../context/UserContext";

import ApiService from "../../services/api.service";

import "../../sass/blocks/_confrim.scss";

const Confirm = (props) => {
    const { pageID, pageAfterQuestions } = props;

    const { step, setStep } = useContext(StepContext);
    const { answers, setAnswers } = useContext(AnswersContext);
    const { user } = useContext(UserContext);

    const sendAnswers = () => {
        ApiService.postQuestions({
            answers,
            user: user,
            pageID,
        });

        setStep(step + 1);
    };

    const parsedContent = JSON.parse(pageAfterQuestions);

    return (
        <>
            <section className="confrim">
                <h2 className="confrim__heading">
                    {pageAfterQuestions.length > 0 &&
                    pageAfterQuestions !== null &&
                    pageAfterQuestions !== "null" &&
                    parsedContent.header_text !== undefined &&
                    parsedContent.header_text !== null &&
                    parsedContent.header_text.length > 0
                        ? parsedContent.header_text
                        : "Dziękujemy za udzielenie odpowiedzi!"}
                </h2>
                <div className="confrim-flex">
                    <button
                        className="confrim-flex__button"
                        onClick={sendAnswers}
                    >
                        Wyślij formularz
                    </button>
                </div>
            </section>
        </>
    );
};

export default Confirm;
